import { getI18n } from 'react-i18next';
import { useMemo } from 'react';
import { setStorageValue } from '@mygpt/app/utils/storage';

import { useLanguageOptions } from './useLanguageOptions';
import { KEY_TRANSLATE_LANGUAGE } from '../../apis/constant';
import { I18N_LANG_MAP } from '../../chat/constant';

export const useGetLanguageInfo = () => {
  const i18n = getI18n();
  const languageOptions = useLanguageOptions();
  const langSelected = languageOptions.find((option) => option.value === i18n.language);

  const languageOnChange = (val: string | null) => {
    if (!val) return;
    i18n.changeLanguage(val);
    setStorageValue({ key: KEY_TRANSLATE_LANGUAGE, value: val, syncToCookie: false });
    document.documentElement.lang = val;
  };

  const voiceLanguage = useMemo(
    () => (langSelected?.value ? I18N_LANG_MAP[langSelected.value] : undefined),
    [langSelected]
  );

  return {
    languageOptions,
    langSelected,
    languageOnChange,
    voiceLanguage,
  };
};
